import api from '../../../lib/api';
import { ResourceFetch } from '../../../meta/types/api';
import { CONFIG } from '../../../meta/types/config';
import { StatisticsServerResponse } from '../../../meta/types/requests-statistics';

const REQUEST_STATISTICS_RESOURCE_BASE_PATH = `${CONFIG.dashboardServiceBasePath}/dashboard/v1/statistics/requests`;

const { GET } = api;

type UserIdStatisticsParams = {
  userId?: string;
  timestamp_gte?: string | null;
};

type UserRangeResolutionParams = {
  userId?: string;
  range?: string;
  resolution?: string;
};

type UserArchiveResolutionParams = {
  userId?: string;
  resolution?: string;
  year: string;
  month: string;
};

interface InstanceStatisticsParams extends UserIdStatisticsParams {
  instanceId?: string;
}

export interface RequestStatisticsResource {
  getRateLimitedRequestsCount: ResourceFetch<{ data: number }, InstanceStatisticsParams>;
  getStatistics: ResourceFetch<StatisticsServerResponse, UserRangeResolutionParams>;
  getArchive: ResourceFetch<StatisticsServerResponse, UserArchiveResolutionParams>;
}

const RequestStatisticsResource: RequestStatisticsResource = {
  getRateLimitedRequestsCount: GET(`${REQUEST_STATISTICS_RESOURCE_BASE_PATH}/rate_limited`),
  getStatistics: GET(`${REQUEST_STATISTICS_RESOURCE_BASE_PATH}/statistics`),
  getArchive: GET(`${REQUEST_STATISTICS_RESOURCE_BASE_PATH}/monthlyStatistics`),
};

export default RequestStatisticsResource;
